exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form[data-v-76c9202f]{max-width:300px}.homeworks[data-v-76c9202f]{width:100%;margin-top:40px;text-align:center}", ""]);

// exports
